// extracted by mini-css-extract-plugin
module.exports = {"itemTableHeader":"Cart_itemTableHeader__L3oXA","itemTableHairline":"Cart_itemTableHairline__mYtLO","itemTableImage":"Cart_itemTableImage__W76sM"};